import { JSONSchemaType } from 'ajv'

export interface ICommerciaPlanFormData {
  name: string
  fixedPrice: number
  lifePrice: number
  lifeLimit: number
  lifeAfterLimitPrice: number
  recipePrice: number
  recipeLimit: number
  recipeAfterLimitPrice: number
  recipeExecutionPrice: number
  recipeExecutionLimit: number
  recipeAfterExecutionLimitPrice: number
  connectorPrice: number
  connectorLimit: number
  connectorAfterLimitPrice: number
  connectorExecutionPrice: number
  connectorExecutionLimit: number
  connectorAfterExecutionLimitPrice: number
  isInactive: boolean
}

const CommerciaPlanSchema: JSONSchemaType<ICommerciaPlanFormData> = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    fixedPrice: {
      type: 'number',
      default: 0,
    },
    lifePrice: {
      type: 'number',
      default: 0,
    },
    lifeLimit: {
      type: 'number',
      default: 0,
    },
    lifeAfterLimitPrice: {
      type: 'number',
      default: 0,
    },
    recipePrice: {
      type: 'number',
      default: 0,
    },
    recipeLimit: {
      type: 'number',
      default: 0,
    },
    recipeAfterLimitPrice: {
      type: 'number',
      default: 0,
    },
    recipeExecutionPrice: {
      type: 'number',
      default: 0,
    },
    recipeExecutionLimit: {
      type: 'number',
      default: 0,
    },
    recipeAfterExecutionLimitPrice: {
      type: 'number',
      default: 0,
    },
    connectorPrice: {
      type: 'number',
      default: 0,
    },
    connectorLimit: {
      type: 'number',
      default: 0,
    },
    connectorAfterLimitPrice: {
      type: 'number',
      default: 0,
    },
    connectorExecutionPrice: {
      type: 'number',
      default: 0,
    },
    connectorExecutionLimit: {
      type: 'number',
      default: 0,
    },
    connectorAfterExecutionLimitPrice: {
      type: 'number',
      default: 0,
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['name'],
  additionalProperties: false,
}

export default CommerciaPlanSchema
